<template lang="pug">
  v-autocomplete(
    v-model="inputValue"
    :label="label"
    :items="items"
    item-text="name"
    item-value="id"
    v-bind="$attrs"
    v-on="$listeners"
    clearable
  )
</template>

<script>
import { CACHE_KEYS } from '@/store/modules/cache';
import { mapActions, mapGetters } from 'vuex';
import { CRUDProjects } from '@/services/API/project';

export default {
  props: {
    value: { type: Number, default: null },
    label: { type: String, default: 'Проект' },
    mandatory: { type:Boolean, default: false },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    ...mapGetters({
      projects:'cache/cachedProjects',
    }),
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      'loadToCache':'cache/loadToCache',
    }),
    init() {
      this.loadItems();
    },
    async loadItems() {
      CRUDProjects.getAll().then(async (response) => {
        this.items = response.data.data;
        const projectIds = this.items.map(({ id }) => id);
        if (!this.projects.length) {
          await this.loadToCache({ key:CACHE_KEYS.projects, ids:projectIds });
        }
        if (this.mandatory) {
          this.$emit('input', this.items[0]?.id);
        }
      });
    },
  },
};
</script>
